const DefaultSponsor = () => [
  {
    id: 189,
    img_og:
      "https://img.freepik.com/free-photo/grunge-concrete-material-background-texture-wall-concept_53876-42916.jpg?w=2000",
    title: "vintage Backgrounds",
    premium: false,
    author: "Ahmed Ali",
    authour_image:
      "https://rextheme.com/wp-content/themes/RexTheme/images/testimonial-author-placeholder-img.png",
    authour_assets: 622,
    category: "Backgrounds",
    sub_category: "Patterns",
    likes: 489,
    color: "coral",
    num_people: 1,
    age: "middle age",
    gender: "Female",
    ethinicity: "asian",
    file_type: "raw",
    undiscovered: false,
    style: "Flat",
    publish_date: "25-10-2016",
    choice: false,
    related_tags: ["vintage", "Backgrounds", "coral", "asian", "middle age"],
    img_path: "189.jpeg",
  },
  {
    id: 197,
    img_og:
      "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8c2VhJTIwYmFja2dyb3VuZHxlbnwwfHwwfHw%3D&w=1000&q=80",
    title: "sea Backgrounds",
    premium: false,
    author: "Samer Salah",
    authour_image:
      "https://rextheme.com/wp-content/themes/RexTheme/images/testimonial-author-placeholder-img.png",
    authour_assets: 862,
    category: "Backgrounds",
    sub_category: "Patterns",
    likes: 36,
    color: "magenta",
    num_people: 3,
    age: "elderly",
    gender: "Male",
    ethinicity: "arabic",
    file_type: "psd",
    undiscovered: false,
    style: "Portrait",
    publish_date: "23-11-2022",
    choice: true,
    related_tags: ["sea", "Backgrounds", "magenta", "arabic", "elderly"],
    img_path: "197.jpeg",
  },
  {
    id: 206,
    img_og:
      "https://img.freepik.com/free-vector/gradient-pastel-sky-background_23-2148908629.jpg?w=2000",
    title: "pastel Backgrounds",
    premium: true,
    author: "Samer Ahmed",
    authour_image:
      "https://rextheme.com/wp-content/themes/RexTheme/images/testimonial-author-placeholder-img.png",
    authour_assets: 946,
    category: "Backgrounds",
    sub_category: "Symbols and signs",
    likes: 333,
    color: "purple",
    num_people: 2,
    age: "middle age",
    gender: "Male",
    ethinicity: "white",
    file_type: "jpg",
    undiscovered: true,
    style: "Portrait",
    publish_date: "10-10-2020",
    choice: true,
    related_tags: ["pastel", "Backgrounds", "purple", "white", "middle age"],
    img_path: "206.jpeg",
  },
  {
    id: 207,
    img_og:
      "https://images.pexels.com/photos/302769/pexels-photo-302769.jpeg?cs=srgb&dl=pexels-pixabay-302769.jpg&fm=jpg",
    title: "building Backgrounds",
    premium: true,
    author: "Hassan Khaled",
    authour_image:
      "https://rextheme.com/wp-content/themes/RexTheme/images/testimonial-author-placeholder-img.png",
    authour_assets: 552,
    category: "Backgrounds",
    sub_category: "Posters",
    likes: 719,
    color: "azure",
    num_people: 5,
    age: "middle age",
    gender: "Male",
    ethinicity: "south african",
    file_type: "eps",
    undiscovered: false,
    style: "Portrait",
    publish_date: "15-10-2016",
    choice: false,
    related_tags: [
      "building",
      "Backgrounds",
      "azure",
      "south african",
      "middle age",
    ],
    img_path: "207.jpeg",
  },
  {
    id: 223,
    img_og:
      "https://img.freepik.com/free-photo/top-view-frame-with-delicious-food-copy-space_23-2148306310.jpg?w=2000",
    title: "thanksgiving Backgrounds",
    premium: true,
    author: "Khaled Hassan",
    authour_image:
      "https://rextheme.com/wp-content/themes/RexTheme/images/testimonial-author-placeholder-img.png",
    authour_assets: 732,
    category: "Backgrounds",
    sub_category: "Business cards",
    likes: 997,
    color: "yellow",
    num_people: 2,
    age: "child",
    gender: "Female",
    ethinicity: "asian",
    file_type: "psd",
    undiscovered: false,
    style: "Portrait",
    publish_date: "13-10-2017",
    choice: true,
    related_tags: ["thanksgiving", "Backgrounds", "yellow", "asian", "child"],
    img_path: "223.jpeg",
  },
  {
    id: 224,
    img_og:
      "https://i.pinimg.com/originals/a7/76/49/a77649556c5008051ae0036f7170bd87.jpg",
    title: "woods Backgrounds",
    premium: true,
    author: "Khaled Salem",
    authour_image:
      "https://rextheme.com/wp-content/themes/RexTheme/images/testimonial-author-placeholder-img.png",
    authour_assets: 229,
    category: "Backgrounds",
    sub_category: "Posters",
    likes: 263,
    color: "grey",
    num_people: 3,
    age: "young adult",
    gender: "Female",
    ethinicity: "south african",
    file_type: "svg",
    undiscovered: false,
    style: "Portrait",
    publish_date: "27-11-2015",
    choice: false,
    related_tags: [
      "woods",
      "Backgrounds",
      "grey",
      "south african",
      "young adult",
    ],
    img_path: "224.jpeg",
  },
  {
    id: 225,
    img_og: "https://wallpaperaccess.com/full/3265126.jpg",
    title: "day Backgrounds",
    premium: true,
    author: "Samer Sami",
    authour_image:
      "https://rextheme.com/wp-content/themes/RexTheme/images/testimonial-author-placeholder-img.png",
    authour_assets: 563,
    category: "Backgrounds",
    sub_category: "Business cards",
    likes: 120,
    color: "coral",
    num_people: 3,
    age: "elder",
    gender: "Female",
    ethinicity: "black",
    file_type: "jpeg",
    undiscovered: true,
    style: "Portrait",
    publish_date: "11-11-2020",
    choice: true,
    related_tags: ["day", "Backgrounds", "coral", "black", "elder"],
    img_path: "225.jpeg",
  },
];
export default DefaultSponsor;
